export interface WorkingHours {
    enabled: boolean
    startTime: string
    endTime: string
    workingDays: number[]
}

export interface ResolvedWorkingHours extends WorkingHours {
    source: 'user' | 'org' | 'default' | 'merged'
}

export const DEFAULT_WORKING_HOURS: WorkingHours = {
    enabled: false,
    startTime: '08:00',
    endTime: '18:00',
    workingDays: [1, 2, 3, 4, 5],
}

export const WEEKDAY_LABELS: Record<number, string> = {
    0: 'Sun',
    1: 'Mon',
    2: 'Tue',
    3: 'Wed',
    4: 'Thu',
    5: 'Fri',
    6: 'Sat',
}

export const WEEKDAY_FULL_LABELS: Record<number, string> = {
    0: 'Sunday',
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
}
